
import { useEffect, useState } from 'react'
import CtaButton from '../../components/ctaButton/CtaButton'
import './style.scss'
import { useDispatch } from 'react-redux'
import { setShowWatchVideos } from '../../redux/reducers/chatSlice'
import { userStateData } from '../../data/userStateData';
import { useAppSelector } from '../../redux/hooks'
import { interactionConnector } from '../../server/connector/interactionConnector'
import { ChatInteractions, VideoUploadResponse } from '../../server/types';
import { ChatMessage, InteractionStatus } from '../../types/types'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { MAX_VIDEO_FILE_SIZE } from '../../constants/constants'

type InteractionJson = {
	messages?: ChatMessage[]
}

function AdminChatContentArea() {
	const [messages, setMessages] = useState<ChatMessage[]>([])

	const chatDataLoaded: boolean = useAppSelector(state => state.user.chatDataLoaded)

	const dispatch = useDispatch()

	// Setup test values
	useEffect(() => {
		if (chatDataLoaded === true) {
			const interaction: ChatInteractions | undefined = userStateData.getInteractionData()
			if (interaction && interaction.interaction_data.length > 0) {
				const sanatizedData: string = interaction.interaction_data.replace(/(\r\n|\n|\r)/gm, "") // .replace('\n', '') // .replace(/[\\]/g, '\\\\').replace(/[\"]/g, '\\\"').replace(/[\/]/g, '\\/').replace(/[\f]/g, '\\f').replace(/[\n]/g, '\\n').replace(/[\r]/g, '\\r').replace(/[\t]/g, '\\t')
				// console.log(interaction.interaction_data)
				const interactionObj: InteractionJson = JSON.parse(sanatizedData) // interaction.interaction_data)
				if (interactionObj.messages) {
					// count how many instructor messages have been sent
					setMessages(interactionObj.messages)
				}
			}
		}
	}, [chatDataLoaded])

	
	const videoClickHandler = (fileName: string) => {
		userStateData.setVideoFileName(fileName)
		dispatch(setShowWatchVideos(true))
	}

	const timeSinceMessage = (timeStamp: string) => {
		let currentDate: Date = new Date()
		let messageTime: Date = new Date(parseInt(timeStamp))
		// more than 1 day
		if (currentDate.getTime() - messageTime.getTime() > 86400000) {
			return `${Math.floor((currentDate.getTime() - messageTime.getTime()) / 86400000)} day`
		} else if (currentDate.getTime() - messageTime.getTime() > 3600000) {
			return `${Math.floor((currentDate.getTime() - messageTime.getTime()) / 3600000)} hour(s)`
		} else if (currentDate.getTime() - messageTime.getTime() > 60000) {
			return `${Math.floor((currentDate.getTime() - messageTime.getTime()) / 60000)} mins`
		} else {
			return `${Math.floor((currentDate.getTime() - messageTime.getTime()) / 1000)} secs`
		}
	}

	
	const isMessageSender = (sourceId: string): boolean => {
		if (sourceId == '0') {
			if (userStateData.isAnInstructor()) {
				return true
			} else {
				return false
			}
		} else {
			if (userStateData.isAnInstructor()) {
				return false
			} else {
				return true
			}
		}
	}

	return (
		<div className='dashboard-content-area-wrap'>
			<div className='dashboard-content-area-chat-messages'>
				<div
					className='dashboard-content-area-chat-content'
				>
					{messages.length === 0 ?
						<span>No Active Messages</span>
						:
						messages.map((message: ChatMessage) =>
							<div
								className={isMessageSender(message.sourceId) ? 'dashboard-content-area-chat-message dashboard-content-area-chat-message-sender' : 'dashboard-content-area-chat-message'}
							>
								<img
									className='dashboard-content-area-chat-message-sender-icon'
									alt='profile'
									src={message.profileImgUrl}
								/>
								<div className={isMessageSender(message.sourceId) ? 'dashboard-content-area-chat-message-text-area dashboard-content-area-chat-message-text-area-other' : 'dashboard-content-area-chat-message-text-area'}>
									<div>{
										message.type == 'video' ?
											<>
												<div
													className='mini-video'
													onClick={() => videoClickHandler(message.message)}
												>
													<img
														className='upload-mini-video-play-icon'
														src='/imgs/icons/icon-play-circle.svg'
														alt='Play'
													/>
												</div>
												Video File
											</> :
											message.message.replaceAll('\\"', '"').replaceAll("\\'", "'")
									}</div>
									<div className='dashboard-content-area-chat-message-time'>{timeSinceMessage(message.time)}</div>
								</div>
							</div>
						)
					}
				</div>
			</div>
		</div>
	)
}

export default AdminChatContentArea
